import PropTypes from 'prop-types';
import React from 'react';
import ReactPaginate from 'react-paginate';

/**
 * Server paging parameters
 *
 * @typedef PagingParams
 * @property {number} pageNumber
 * @property {number} pageSize
 * @property {number} pages
 * @property {number} total
 */

export default class Paging extends React.PureComponent {
    handlePageClick = data => {
        const pageNumber = data.selected + 1;
        this.props.onPageChange({ pageNumber });
    };
    render() {
        let { pages, pageNumber = 1 } = this.props;

        pages = parseInt(pages, 10);
        pageNumber = parseInt(pageNumber, 10);

        if (pages > 1) {
            return (
                <div className="text-block">
                    <ReactPaginate
                        disableInitialCallback={true}
                        pageRangeDisplayed={4}
                        marginPagesDisplayed={0}
                        breakLabel={<span className="page-link">...</span>}
                        previousLabel={'← Previous'}
                        nextLabel={'Next →'}
                        pageCount={pages}
                        onPageChange={this.handlePageClick}
                        forcePage={pageNumber - 1}
                        containerClassName={'pagination justify-content-center'}
                        disabledClassName={'disabled'}
                        activeClassName={'active'}
                        pageClassName={'page-item'}
                        pageLinkClassName={'page-link'}
                        previousClassName={'page-item'}
                        previousLinkClassName={'page-link'}
                        nextClassName={'page-item'}
                        nextLinkClassName={'page-link'}
                    />
                </div>
            );
        }

        return null;
    }
}

Paging.propTypes = {
    pages: PropTypes.number.isRequired,
    pageNumber: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
};
